import { Component } from '@angular/core';

@Component({
  selector: 'vtab-action-top',
  templateUrl: './vtab-action-top.component.html',
  styleUrls: ['./vtab-action-top.component.scss'],
  standalone: false,
})
export class VTabActionTopComponent {}
